import React from 'react'

function About() {
    return (
        <div>
            <div className='flex flex-col h-[80vh] font-light font-serif justify-center items-center w-full text-lg md:text-2xl'>
                
                   <div className='w-5/6 md:w-2/3'> Hi, My name is Vishal Garg. I'm a programmer and designer working mainly on interaction design & web development. My day to day tools include Javascript, React, NodeJS, Firebase, Tailwind & Material UI . Currently I'm exploring Web 3.0 & Blockchain. In my spare time I enjoy sketching, reading light novels & learning about space and astronomy.</div> 
                    <br/>
                   <div className='w-5/6 md:w-2/3' >I can be reached at  gargvishal3564@gmail.com</div> 
                
            </div>
        </div>
    )
}

export default About
